import { render, staticRenderFns } from "./BalcaoStatusView.vue?vue&type=template&id=09746ab4&scoped=true&"
import script from "./BalcaoStatusView.vue?vue&type=script&lang=js&"
export * from "./BalcaoStatusView.vue?vue&type=script&lang=js&"
import style0 from "./BalcaoStatusView.vue?vue&type=style&index=0&id=09746ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09746ab4",
  null
  
)

export default component.exports